import ModuleThreeReflection from "../../../../src/components/forms/ModuleThreeReflection";
import * as React from 'react';
export default {
  ModuleThreeReflection,
  React
};